import { render, staticRenderFns } from "./PromotionMetric.vue?vue&type=template&id=3ccfaee3"
import script from "./PromotionMetric.vue?vue&type=script&lang=js"
export * from "./PromotionMetric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports